module.exports = __webpack_public_path__ + "media/images/green_ball-35d477bdfdc2649af8717830dfe69262.png";